// extracted by mini-css-extract-plugin
var _1 = "EmbedFallback-module__animateUploadProgressBarWidth--YbZjd";
var _2 = "EmbedFallback-module__animatedBackground--WNNug";
var _3 = "EmbedFallback-module__button--g3tI5";
var _4 = "EmbedFallback-module__fallback--VAjz_";
var _5 = "EmbedFallback-module__message--OFem5";
var _6 = "EmbedFallback-module__title--GoUHV";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "fallback", _5 as "message", _6 as "title" }
